import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { Commitment } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';

export function getSetup(util: UtilityService, dialog: DialogService, currentPage: string): GridSetup<Commitment> {
	return {
		rowName: { singular: 'Commitment', plural: 'Commitments' },
		getRowKey: row => '' + row.commitmentId,
		stateKey: `${currentPage}-commitments-grid`,
		actions: getActions(dialog),
		buttons: [],
		columns: getColumns(util)
	}
}
